import { useContext } from 'react';
import { Context } from './CreateNotice';
import { useTheme } from '@mui/material';
import { ACCOUNT_TYPES, NOTICE_CATEGORIES } from '../common/constants';
import PreviewImages from './common/PreviewImages';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

const PreviewDialog = () => {
  const { palette, typography } = useTheme();
  const styles = {
    backButton: {
      ...typography.label14,
      width: '224px',
      height: '44px',
      borderRadius: '100px',
      marginLeft: 'auto',
      marginRight: '8px',
      color: 'primary.light',
      border: `1px solid ${palette.primary.light}`,
    },
    submitButton: {
      ...typography.label14bold,
      width: '232px',
      height: '44px',
      borderRadius: '100px',
      margin: 'auto',
      backgroundColor: 'primary.light',
    },
  };

  const {
    openPreview, setOpenPreview,
    receivers, handleSubmit, noticeArray,
  } = useContext(Context);

  let previewNoticeArray = structuredClone(noticeArray);
  // indexがnullの場合は全ての通告を表示
  if (openPreview.index !== null) previewNoticeArray = previewNoticeArray.filter((_, i) => i === openPreview.index);
  // 送信済みの通告を除外
  previewNoticeArray = previewNoticeArray.filter((notice) => notice.sentAt === undefined);

  return (
    <Dialog
      open={openPreview.isOpen}
      onClose={() => setOpenPreview({ isOpen: false, index: openPreview.index })}
      maxWidth='md'
    >

      <DialogTitle variant='body16bold' textAlign='center' position='relative'>
        通告プレビュー（トレーニング用）
        <IconButton
          sx={{ position: 'absolute', right: '6px', top: '0px', bottom: '0px' }}
          onClick={() => setOpenPreview({ isOpen: false, index: openPreview.index })}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ padding: '24px 96px' }}>
        <Stack direction='row'>
          <DialogContentText variant='caption13' marginRight='12px'>送信先</DialogContentText>
          <Stack direction='column'>
            {Object.values(receivers).map((receiver) => {
              return (
                <Stack key={receiver.employeeNumber} direction='row'>
                  <DialogContentText variant='body14bold' marginRight='8px'>{receiver.employeeNumber}</DialogContentText>
                  <DialogContentText variant='body14bold' marginRight='4px'>{receiver.name}</DialogContentText>
                  <DialogContentText variant='body14bold'>
                    {Object.values(ACCOUNT_TYPES).find((t) => t.value === receiver.accountType).label}
                  </DialogContentText>
                </Stack>
              );
            })}
          </Stack>
        </Stack>
        <Divider sx={{ margin: '24px 0px' }} />
        {previewNoticeArray.map((notice) => (
          <Stack key={notice.id} marginBottom='7px'>
            <Stack direction='row' marginBottom='4px'>
              <DialogContentText variant='caption13' width='100px' marginRight='4px'>送信タイミング</DialogContentText>
              <DialogContentText variant='body14bold'>
                {notice.isImmediate ? '即時送信' : `予約送信 ${notice.delayMin}分${notice.delaySec}秒後`}
              </DialogContentText>
            </Stack>
            <Stack direction='row' marginBottom='4px'>
              <DialogContentText variant='caption13' width='100px' marginRight='4px' >通告の種類</DialogContentText>
              <DialogContentText variant='body14bold'>
                {Object.values(NOTICE_CATEGORIES).find((category) => category.value === notice.noticeCategoryCode)?.label}
              </DialogContentText>
            </Stack>
            <PreviewImages notice={notice} />
          </Stack>
        ))}
        <DialogActions sx={{ padding: '0px', paddingTop: '24px' }}>
          <Button
            variant='outlined' sx={styles.backButton}
            onClick={() => setOpenPreview({ isOpen: false, index: openPreview.index })}
          >
            作成画面に戻る
          </Button>
          <Button
            variant='contained' disableElevation sx={styles.submitButton}
            onClick={() => {
              handleSubmit(openPreview.index);
            }}
          >
            この内容で送信する
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewDialog;
